var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/product-grid/product-grid-rec-tray.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/contentful/product-grid/product-grid-rec-tray.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
var t_5;
t_5 = runtime.contextOrFrameLookup(context, frame, "rrData");
frame.set("rrRecs", t_5, true);
if(frame.topLevel) {
context.setVariable("rrRecs", t_5);
}
if(frame.topLevel) {
context.addExport("rrRecs", t_5);
}
output += "\n";
var t_6;
t_6 = "--" + "" + env.getFilter("replace").call(context, env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "displayType"))," ","-");
frame.set("displayTypeClass", t_6, true);
if(frame.topLevel) {
context.setVariable("displayTypeClass", t_6);
}
if(frame.topLevel) {
context.addExport("displayTypeClass", t_6);
}
output += "\n";
var t_7;
t_7 = (lineno = 4, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.productTileType","NO_DETAILS"]));
frame.set("tileTemplate", t_7, true);
if(frame.topLevel) {
context.setVariable("tileTemplate", t_7);
}
if(frame.topLevel) {
context.addExport("tileTemplate", t_7);
}
output += "\n\n<span class=\"dom-rr-container\">";
if(runtime.contextOrFrameLookup(context, frame, "rrRecs")) {
output += "<div class=\"o-row o-column o-extra-small--12 s-contentful-product-grid s-contentful-product-grid";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "displayTypeClass"), env.opts.autoescape);
output += " dom-product-tray-content\" data-index=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
output += ">";
frame = frame.push();
var t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"recs");
if(t_10) {var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("product", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += runtime.suppressValue((lineno = 14, colno = 35, runtime.callWrap(t_4, "displayProductTile", context, [runtime.memberLookup((t_11),"product"),runtime.makeKeywordArgs({"tileTemplate": runtime.contextOrFrameLookup(context, frame, "tileTemplate"),"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")})])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</div>";
;
}
output += "</span>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/product-grid/product-grid-rec-tray.j2"] , dependencies)